import { render, staticRenderFns } from "./SkupPrijavaBase.vue?vue&type=template&id=80fa4d7a&scoped=true&"
import script from "./SkupPrijavaBase.vue?vue&type=script&lang=js&"
export * from "./SkupPrijavaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fa4d7a",
  null
  
)

export default component.exports